var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-full"},[_c('div',{staticClass:"notification",class:[_vm.color]},[_c('button',{staticClass:"delete",on:{"click":function($event){_vm.show = !_vm.show}}}),_vm._v(" "+_vm._s(_vm.message)+" ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }